import { render, staticRenderFns } from "./VarGroupSelector.vue?vue&type=template&id=1b7d94ff&scoped=true&"
import script from "./VarGroupSelector.vue?vue&type=script&lang=js&"
export * from "./VarGroupSelector.vue?vue&type=script&lang=js&"
import style0 from "./VarGroupSelector.vue?vue&type=style&index=0&id=1b7d94ff&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b7d94ff",
  null
  
)

export default component.exports